// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Loader_wrapper__KtpxC","loader":"Loader_loader__V7xyZ","spin":"Loader_spin__7h4b5"};